import React from 'react'

function SimpleFooter() {
  return (
<div className="bg-[#3662E3] max-w-screen overflow-hidden ">
  
  <div className="flex py-5 m-auto text-gray-200 text-sm flex-col items-center ">
    <p>© Copyright 2025. The Weather Agency</p>
  </div>
</div>

  )
}

export default SimpleFooter